module.exports = __webpack_public_path__ + "w.no1.1864d629.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/w.no1.jpg
// module id = tOOL
// module chunks = 0